import { render, staticRenderFns } from "./UserChannels.vue?vue&type=template&id=c2bffaae&scoped=true&"
import script from "./UserChannels.ts?vue&type=script&lang=ts&"
export * from "./UserChannels.ts?vue&type=script&lang=ts&"
import style1 from "./UserChannels.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bffaae",
  null
  
)

export default component.exports